<template>
  <div>
    <div>
      <PrimaryButton text="見積検索" class="bg-blue-500" @click="seachHistory()">
        <Icon slot="before" iconName="SearchCircle" class="h-5 w-5" />
      </PrimaryButton>
    </div>
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import * as dialogs from '@libs/dialogs'

export default {
  components: {
    Icon,
    PrimaryButton
  },

  props: {
    // メインタスク画面からの検索
    fromMainTask: {
      type: Boolean,
      default: false
    },
    // 検索対象データ
    target: {
      type: Object
    },
  },

  data() {
    return {
    }
  },

  methods: {
    /**
     * 履歴検索
     */
    async seachHistory() {
      // 物件名
      let site = null
      // 物件コード
      let code = null
      // 物件住所
      let address = null
      // メインタスクでの検索の場合
      if (this.fromMainTask) {
        // 対象データを代入
        site = this.target.buildingName
        code = this.target.siteCode
        address = this.target.state + this.target.city + this.target.street

      // 見積り画面での検索の場合
      } else {
        site = this.target.buildingName
        code = this.target.siteCode
        address = this.target.buildingAddress2
      }

      // 何もない場合
      if (!site && !code && !address) {
        await dialogs.showErrorDialog('検索対象がありません', '建物名、もしくは建物住所を入力してください。')
        return
      }
      if (site) {
        site = site.trim()
      }
      if (address) {
        address = address.trim()
      }
      if (code) {
        code = code.trim()
      }

      let route = this.$router.resolve({
        name: 'EstimateHistorySearch',
        query: { site, code, address }
      })
      window.open(route.href, '_blank')
    }
  }
}
</script>